import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { isEmailValid } from "../../shared/shared";

const ForgotPasswordModal = (props) => {

  const { handleClose, handleOk, open } = props;
  const [email, setEmail] = useState({
    value: "",
    isValid: true,
    errorMessage: "",
  });

  const validate = () => {
    if (isEmailValid(email.value)) handleOk(email.value);
    else
      setEmail({
        ...email,
        isValid: false,
        errorMessage: "Input a valid Email",
      });
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={open}
      onClose={() => {
        handleClose();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <DialogTitle>
        {"Forgot Password"}
      </DialogTitle>
      <DialogContent style={{ margin: "auto" }}>

        <TextField
          size="small"
          label="Email"
          variant="standard"
          style={{ width: 350 }}
          value={email.value}
          onChange={(event) =>
            setEmail({
              value: event.target.value,
              isValid: true,
              errorMessage: "",
            })
          }
          error={!email.isValid}
          helperText={email.errorMessage}
          errorMessage="yes"
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button onClick={validate}>Recover</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ForgotPasswordModal;
